import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';
import { db, auth, googleProvider } from '../firebase';
import { signInWithPopup, signOut as firebaseSignOut } from 'firebase/auth';
import {
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  onSnapshot,
  serverTimestamp,
} from 'firebase/firestore';
import {
  fileToFirestoreProofDataUrl,
  validatePaymentProofFile,
} from '../utils/paymentProof';

const LS = {
  get: k => {
    try {
      return JSON.parse(localStorage.getItem(k));
    } catch {
      return null;
    }
  },
  set: (k, v) => {
    try {
      localStorage.setItem(k, JSON.stringify(v));
    } catch {}
  },
};

const SEED_USERS = [
  {
    id: 'u1',
    name: 'Ali Hassan',
    username: 'student1',
    password: 'pass123',
    approved: true,
    requestedAt: null,
  },
  {
    id: 'u2',
    name: 'Fatima Malik',
    username: 'fatima',
    password: 'learn22',
    approved: true,
    requestedAt: null,
  },
  {
    id: 'u3',
    name: 'Sara Khan',
    username: 'sara',
    password: 'learn123',
    approved: true,
    requestedAt: null,
  },
  {
    id: 'u4',
    name: 'Bilal Ahmed',
    username: 'bilal',
    password: 'skill123',
    approved: true,
    requestedAt: null,
  },
  {
    id: 'u5',
    name: 'Ayesha Noor',
    username: 'ayesha',
    password: 'course123',
    approved: false,
    requestedAt: '2026-05-14T09:30:00.000Z',
  },
];
const SEED_ADMINS = [
  {
    id: 'a1',
    username: 'admin',
    password: 'Admin@Vault#99',
    name: 'System Admin',
  },
];
const SEED_INSTRUCTORS = [
  {
    id: 'i1',
    email: 'instructor@gmail.com',
    password: 'teach123',
    name: 'MR. ADNAN',
    about:
      'Top Rated Freelancer & Fiverr Expert helping freelancers build high-converting gigs, master client communication, and scale their monthly income.',
    rating: 4.9,
    approved: true,
  },
  {
    id: 'i2',
    email: 'designcoach@gmail.com',
    password: 'teach123',
    name: 'Mariam Design Lab',
    about:
      'Product designer teaching UI, UX, research, and portfolio-building workflows.',
    rating: 4.6,
    approved: true,
  },
  {
    id: 'i3',
    email: 'datapro@gmail.com',
    password: 'teach123',
    name: 'Omar Data Studio',
    about:
      'Data analyst and Python instructor with hands-on analytics projects.',
    rating: 4.8,
    approved: true,
  },
  {
    id: 'i4',
    email: 'businessmentor@gmail.com',
    password: 'teach123',
    name: 'Hira Business School',
    about:
      'Business and marketing instructor teaching practical growth systems.',
    rating: 4.5,
    approved: true,
  },
];
const SEED_COURSES = [
  {
    id: 'c1',
    title: 'Fiverr Master Class For Freelancers',
    instructorId: 'i1',
    thumb:
      'https://images.unsplash.com/photo-1593720219128-218afe5a3e4a?w=600&q=80',
    description:
      'Unlock premium Fiverr freelance techniques, high-converting gigs, and master client communication to skyrocket your freelance career.',
    approved: true,
    status: 'approved',
    isBestSeller: true,
    price: 19.99,
    videos: [
      {
        id: 'v_Q3kjwKjvBXw',
        title: 'Course Preview',
        duration: '10:00',
        url: 'https://youtu.be/Q3kjwKjvBXw',
        thumb: 'https://img.youtube.com/vi/Q3kjwKjvBXw/hqdefault.jpg',
        preview: true,
      },
      {
        id: 'v_wCCk_VzB90Y',
        title: '01 Introduction',
        duration: '9:14',
        url: 'https://youtu.be/wCCk_VzB90Y',
        thumb: 'https://img.youtube.com/vi/wCCk_VzB90Y/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_ohD2RScNJdw',
        title: '02 My Fiverr Profile Visit',
        duration: '3:32',
        url: 'https://youtu.be/ohD2RScNJdw',
        thumb: 'https://img.youtube.com/vi/ohD2RScNJdw/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_9RLFeib0Qnc',
        title: '03 All about Fiverr',
        duration: '12:45',
        url: 'https://youtu.be/9RLFeib0Qnc',
        thumb: 'https://img.youtube.com/vi/9RLFeib0Qnc/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_As8H8cRfMlY',
        title: '04 How to Create Gmail ID And Fiverr Account',
        duration: '8:20',
        url: 'https://youtu.be/As8H8cRfMlY',
        thumb: 'https://img.youtube.com/vi/As8H8cRfMlY/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_WkGCaqtlB4A',
        title: '05 All About Profile',
        duration: '15:30',
        url: 'https://youtu.be/WkGCaqtlB4A',
        thumb: 'https://img.youtube.com/vi/WkGCaqtlB4A/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_qhZm2eiUPyg',
        title: '06 How to Select A Niche',
        duration: '11:45',
        url: 'https://youtu.be/qhZm2eiUPyg',
        thumb: 'https://img.youtube.com/vi/qhZm2eiUPyg/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_cI5UN_XM0G8',
        title: '07 What is Gig in fiverr',
        duration: '10:20',
        url: 'https://youtu.be/cI5UN_XM0G8',
        thumb: 'https://img.youtube.com/vi/cI5UN_XM0G8/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_D54i7WyqWIg',
        title: '08 SEO and keywrods on Fiverr',
        duration: '14:10',
        url: 'https://youtu.be/D54i7WyqWIg',
        thumb: 'https://img.youtube.com/vi/D54i7WyqWIg/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_eht0svo4Dss',
        title: '09 Create Optimized Gig Title and Tags',
        duration: '12:30',
        url: 'https://youtu.be/eht0svo4Dss',
        thumb: 'https://img.youtube.com/vi/eht0svo4Dss/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_jdK7lBXlqJ8',
        title: '10 Set Gig Price',
        duration: '8:45',
        url: 'https://youtu.be/jdK7lBXlqJ8',
        thumb: 'https://img.youtube.com/vi/jdK7lBXlqJ8/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_9fyJYeScAZU',
        title: '11 Gig Description Formula',
        duration: '13:20',
        url: 'https://youtu.be/9fyJYeScAZU',
        thumb: 'https://img.youtube.com/vi/9fyJYeScAZU/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_DkBrsYT-6k8',
        title: '12 Gig Banner Formula and Publish Gig',
        duration: '11:15',
        url: 'https://youtu.be/DkBrsYT-6k8',
        thumb: 'https://img.youtube.com/vi/DkBrsYT-6k8/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_I5_9VY4oDaM',
        title: '13 Summary',
        duration: '7:30',
        url: 'https://youtu.be/I5_9VY4oDaM',
        thumb: 'https://img.youtube.com/vi/I5_9VY4oDaM/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_HAvdAOoh8Fs',
        title: '14 Fiverr Gig Search Results',
        duration: '9:40',
        url: 'https://youtu.be/HAvdAOoh8Fs',
        thumb: 'https://img.youtube.com/vi/HAvdAOoh8Fs/hqdefault.jpg',
        preview: false,
      },
      {
        id: 'v_1mxTNuqbGfM',
        title: '15 Gig performance',
        duration: '10:25',
        url: 'https://youtu.be/1mxTNuqbGfM',
        thumb: 'https://img.youtube.com/vi/1mxTNuqbGfM/hqdefault.jpg',
        preview: false,
      },
    ],
  },
  {
    id: 'c2',
    title: 'React Frontend Masterclass',
    instructorId: 'i1',
    thumb:
      'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=600&q=80',
    description:
      'Build modern React apps with components, hooks, routing, state, and deployment.',
    approved: true,
    status: 'approved',
    isBestSeller: true,
    price: 24.99,
    videos: [
      {
        id: 'v4',
        title: 'React Components & JSX (Secure YouTube)',
        duration: '18:20',
        url: 'https://www.youtube.com/watch?v=Ke90Tje7VS0',
        preview: true,
      },
      {
        id: 'v5',
        title: 'Hooks and State Patterns',
        duration: '26:40',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
        preview: false,
      },
      {
        id: 'v6',
        title: 'Deploying a React App',
        duration: '15:10',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
        preview: false,
      },
    ],
  },
  {
    id: 'c3',
    title: 'UI UX Design Essentials',
    instructorId: 'i2',
    thumb:
      'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=600&q=80',
    description:
      'Learn user research, wireframes, visual systems, prototypes, and portfolio case studies.',
    approved: true,
    status: 'approved',
    isBestSeller: false,
    price: 14.99,
    videos: [
      {
        id: 'v7',
        title: 'Design Thinking Basics',
        duration: '13:05',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v8',
        title: 'Wireframes to Prototype',
        duration: '22:15',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v9',
        title: 'Portfolio Case Study',
        duration: '19:30',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
    ],
  },
  {
    id: 'c4',
    title: 'Python Data Analysis Bootcamp',
    instructorId: 'i3',
    thumb:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80',
    description:
      'Analyze data with Python, pandas, charts, dashboards, and real business datasets.',
    approved: true,
    status: 'approved',
    isBestSeller: true,
    price: 29.99,
    videos: [
      {
        id: 'v10',
        title: 'Python for Data Work',
        duration: '21:00',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v11',
        title: 'Pandas Data Cleaning',
        duration: '31:25',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v12',
        title: 'Charts and Insights',
        duration: '24:18',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
    ],
  },
  {
    id: 'c5',
    title: 'Digital Marketing Strategy',
    instructorId: 'i4',
    thumb:
      'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
    description:
      'Plan campaigns, funnels, email marketing, analytics, and paid growth experiments.',
    approved: true,
    status: 'approved',
    isBestSeller: false,
    price: 12.99,
    videos: [
      {
        id: 'v13',
        title: 'Marketing Funnel Foundations',
        duration: '17:40',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v14',
        title: 'Content and Email Strategy',
        duration: '20:00',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v15',
        title: 'Campaign Analytics',
        duration: '23:12',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
    ],
  },
  {
    id: 'c6',
    title: 'Figma Design System Workshop',
    instructorId: 'i2',
    thumb:
      'https://images.unsplash.com/photo-1613909207039-6b173b755cc1?w=600&q=80',
    description:
      'Create reusable components, style tokens, responsive layouts, and handoff-ready files.',
    approved: true,
    status: 'approved',
    isBestSeller: false,
    price: 16.99,
    videos: [
      {
        id: 'v16',
        title: 'Design Tokens',
        duration: '14:55',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v17',
        title: 'Component Variants',
        duration: '25:32',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
      {
        id: 'v18',
        title: 'Developer Handoff',
        duration: '16:48',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      },
    ],
  },
];

const SEED_REVIEWS = [
  {
    id: 'r1',
    userId: 'u2',
    userName: 'Fatima Malik',
    courseId: 'c1',
    rating: 5,
    comment: 'Clear lessons and easy to follow.',
    createdAt: '2026-05-01T10:00:00.000Z',
  },
  {
    id: 'r2',
    userId: 'u3',
    userName: 'Sara Khan',
    courseId: 'c2',
    rating: 5,
    comment: 'Great React course with practical examples.',
    createdAt: '2026-05-02T10:00:00.000Z',
  },
  {
    id: 'r3',
    userId: 'u4',
    userName: 'Bilal Ahmed',
    courseId: 'c2',
    rating: 4,
    comment: 'Good pace and helpful structure.',
    createdAt: '2026-05-03T10:00:00.000Z',
  },
  {
    id: 'r4',
    userId: 'u1',
    userName: 'Ali Hassan',
    courseId: 'c3',
    rating: 5,
    comment: 'The portfolio section was useful.',
    createdAt: '2026-05-04T10:00:00.000Z',
  },
  {
    id: 'r5',
    userId: 'u2',
    userName: 'Fatima Malik',
    courseId: 'c4',
    rating: 5,
    comment: 'Excellent pandas explanations.',
    createdAt: '2026-05-05T10:00:00.000Z',
  },
  {
    id: 'r6',
    userId: 'u3',
    userName: 'Sara Khan',
    courseId: 'c5',
    rating: 4,
    comment: 'Strong overview of funnels and analytics.',
    createdAt: '2026-05-06T10:00:00.000Z',
  },
  {
    id: 'r7',
    userId: 'u4',
    userName: 'Bilal Ahmed',
    courseId: 'c6',
    rating: 4,
    comment: 'Solid Figma workflow.',
    createdAt: '2026-05-07T10:00:00.000Z',
  },
];

const SEED_ENROLLMENTS = [
  {
    id: 'e1',
    userId: 'u1',
    userName: 'Ali Hassan',
    courseId: 'c1',
    status: 'approved',
    requestedAt: '2026-05-01T09:00:00.000Z',
  },
  {
    id: 'e2',
    userId: 'u2',
    userName: 'Fatima Malik',
    courseId: 'c1',
    status: 'approved',
    requestedAt: '2026-05-01T09:10:00.000Z',
  },
  {
    id: 'e3',
    userId: 'u3',
    userName: 'Sara Khan',
    courseId: 'c2',
    status: 'approved',
    requestedAt: '2026-05-02T09:00:00.000Z',
  },
  {
    id: 'e4',
    userId: 'u4',
    userName: 'Bilal Ahmed',
    courseId: 'c2',
    status: 'approved',
    requestedAt: '2026-05-02T09:10:00.000Z',
  },
  {
    id: 'e5',
    userId: 'u1',
    userName: 'Ali Hassan',
    courseId: 'c3',
    status: 'approved',
    requestedAt: '2026-05-03T09:00:00.000Z',
  },
  {
    id: 'e6',
    userId: 'u2',
    userName: 'Fatima Malik',
    courseId: 'c4',
    status: 'approved',
    requestedAt: '2026-05-04T09:00:00.000Z',
  },
  {
    id: 'e7',
    userId: 'u3',
    userName: 'Sara Khan',
    courseId: 'c5',
    status: 'approved',
    requestedAt: '2026-05-05T09:00:00.000Z',
  },
  {
    id: 'e8',
    userId: 'u4',
    userName: 'Bilal Ahmed',
    courseId: 'c6',
    status: 'approved',
    requestedAt: '2026-05-06T09:00:00.000Z',
  },
];

const AuthCtx = createContext(null);

const mergeById = (existing, seeded) => {
  const map = new Map((existing || []).map(item => [item.id, item]));
  seeded.forEach(item => {
    if (!map.has(item.id)) map.set(item.id, item);
  });
  return Array.from(map.values());
};

/** Load catalog from localStorage immediately (avoids splash flash on first paint). */
const bootstrapCatalog = () => {
  const instructors = mergeById(LS.get('lv_instructors'), SEED_INSTRUCTORS).map(
    inst => {
      const seed = SEED_INSTRUCTORS.find(s => s.id === inst.id);
      return {
        ...inst,
        name: seed ? seed.name : inst.name,
        about: seed ? seed.about : inst.about,
      };
    }
  );
  const courses = mergeById(LS.get('lv_courses'), SEED_COURSES).map(course => {
    const seed = SEED_COURSES.find(s => s.id === course.id);
    return {
      ...course,
      title: seed ? seed.title : course.title,
      description: seed ? seed.description : course.description,
      price: course.price ?? seed?.price ?? 0,
      videos: seed
        ? seed.videos
        : (course.videos || []).map((video, index) => ({
            ...video,
            preview: video.preview ?? index === 0,
          })),
    };
  });
  const reviews = mergeById(LS.get('lv_reviews'), SEED_REVIEWS);
  const enrollments = mergeById(LS.get('lv_enrollments'), SEED_ENROLLMENTS);
  const progress = LS.get('lv_progress') || [];
  const cart = LS.get('lv_cart') || [];

  LS.set('lv_instructors', instructors);
  LS.set('lv_courses', courses);
  if (!LS.get('lv_progress')) LS.set('lv_progress', []);
  LS.set('lv_reviews', reviews);
  LS.set('lv_enrollments', enrollments);
  if (!LS.get('lv_cart')) LS.set('lv_cart', []);

  return { instructors, courses, progress, reviews, enrollments, cart };
};

const INITIAL_CATALOG = bootstrapCatalog();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [currentInstructor, setCurrentInstructor] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [users, setUsers] = useState([]);
  const [instructors, setInstructors] = useState(INITIAL_CATALOG.instructors);
  const [courses, setCourses] = useState(INITIAL_CATALOG.courses);
  const [progress, setProgress] = useState(INITIAL_CATALOG.progress);
  const [reviews, setReviews] = useState(INITIAL_CATALOG.reviews);
  const [enrollments, setEnrollments] = useState(INITIAL_CATALOG.enrollments);
  const [cart, setCart] = useState(INITIAL_CATALOG.cart);

  // ── Firestore real-time listener for users ─────────────────────────────
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'users'), snapshot => {
      const firestoreUsers = snapshot.docs.map(d => ({
        id: d.id,
        ...d.data(),
      }));
      setUsers(firestoreUsers);
      // Keep currentUser in sync when admin approves
      setCurrentUser(prev => {
        if (!prev) return prev;
        const fresh = firestoreUsers.find(u => u.id === prev.id);
        return fresh || prev;
      });
    });
    return () => unsubscribe();
  }, []);

  // ── Firestore real-time listener for course settings / prices ────────────
  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'settings', 'courses'),
      snapshot => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          if (data?.prices) {
            setCourses(prev => {
              const updated = prev.map(c =>
                data.prices[c.id] !== undefined
                  ? { ...c, price: Number(data.prices[c.id]) }
                  : c
              );
              LS.set('lv_courses', updated);
              return updated;
            });
          }
        }
      },
      () => {
        // Fallback silently if offline or permission denied
      }
    );
    return () => unsubscribe();
  }, []);

  // ── Restore session from localStorage on reload ────────────────────────
  useEffect(() => {
    const savedId = localStorage.getItem('lv_session_id');
    const savedRole = localStorage.getItem('lv_session_role');
    if (savedRole === 'admin') {
      setIsAdmin(true);
      return;
    }
    if (savedId && savedRole === 'student') {
      getDoc(doc(db, 'users', savedId))
        .then(snap => {
          if (snap.exists()) setCurrentUser({ id: snap.id, ...snap.data() });
        })
        .catch(() => {});
    }
  }, []);

  // saveUsers kept for legacy enrollments only — user state comes from Firestore onSnapshot
  const saveInstructors = i => {
    LS.set('lv_instructors', i);
    setInstructors(i);
  };
  const saveCourses = c => {
    LS.set('lv_courses', c);
    setCourses(c);
  };
  const saveProgress = p => {
    LS.set('lv_progress', p);
    setProgress(p);
  };
  const saveReviews = r => {
    LS.set('lv_reviews', r);
    setReviews(r);
  };
  const saveEnrollments = e => {
    LS.set('lv_enrollments', e);
    setEnrollments(e);
  };
  const saveCart = c => {
    LS.set('lv_cart', c);
    setCart(c);
  };

  const nameFromEmail = email => {
    const local = (email || '').split('@')[0] || 'Instructor';
    return local.replace(/[._-]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  const loginStudent = async (username, password) => {
    try {
      const q = query(
        collection(db, 'users'),
        where('username', '==', username),
        where('password', '==', password)
      );
      const snap = await getDocs(q);
      if (snap.empty) return { error: 'Wrong username or password.' };
      const u = { id: snap.docs[0].id, ...snap.docs[0].data() };
      setCurrentUser(u);
      localStorage.setItem('lv_session_id', u.id);
      localStorage.setItem('lv_session_role', 'student');
      return { user: u };
    } catch (e) {
      console.error('Login Error:', e);
      return { error: 'Login failed: ' + e.message };
    }
  };

  const loginAdmin = async (username, password) => {
    try {
      const q = query(
        collection(db, 'admins'),
        where('username', '==', username)
      );
      const snap = await getDocs(q);

      if (snap.empty) {
        const seedAdmin = SEED_ADMINS.find(
          a => a.username === username && a.password === password
        );
        if (seedAdmin) {
          await addDoc(collection(db, 'admins'), {
            username: seedAdmin.username,
            password: seedAdmin.password,
            name: seedAdmin.name,
            createdAt: serverTimestamp(),
          });
          setIsAdmin(true);
          localStorage.setItem('lv_session_role', 'admin');
          return { success: true };
        }
        return { error: 'Invalid admin credentials.' };
      }

      const adminDoc = snap.docs[0].data();
      if (adminDoc.password === password) {
        setIsAdmin(true);
        localStorage.setItem('lv_session_role', 'admin');
        return { success: true };
      }

      return { error: 'Invalid admin credentials.' };
    } catch (e) {
      console.error('Admin Login Error:', e);
      return { error: 'Login failed: ' + e.message };
    }
  };

  const loginInstructor = (email, password) => {
    if (!email.includes('@gmail.com')) return { error: 'Use a Gmail address.' };
    const all = LS.get('lv_instructors') || [];
    let found = all.find(i => i.email.toLowerCase() === email.toLowerCase());
    if (found && found.password !== password)
      return { error: 'Wrong instructor password.' };
    if (found && found.approved === false)
      return { error: 'Instructor account is waiting for admin approval.' };
    if (!found) {
      found = {
        id: `i_${Date.now()}`,
        email,
        password,
        name: nameFromEmail(email),
        about: 'New instructor',
        rating: 0,
        approved: false,
        requestedAt: new Date().toISOString(),
      };
      saveInstructors([...all, found]);
      return { error: 'Instructor signup submitted. Wait for admin approval.' };
    }
    setCurrentInstructor(found);
    return { instructor: found };
  };

  const logout = () => {
    setCurrentUser(null);
    setCurrentInstructor(null);
    setIsAdmin(false);
    localStorage.removeItem('lv_session_id');
    localStorage.removeItem('lv_session_role');
    firebaseSignOut(auth).catch(() => {});
  };

  /** Save payment proof in Firestore as compressed base64 (Spark plan — no Storage needed). */
  const savePaymentScreenshot = async file => {
    const proofErr = validatePaymentProofFile(file);
    if (proofErr) throw new Error(proofErr.error);
    return fileToFirestoreProofDataUrl(file);
  };

  const signupStudent = async ({
    name,
    username,
    password,
    paymentRef,
    email,
    phone,
    paymentScreenshot,
  }) => {
    try {
      const proofErr = validatePaymentProofFile(paymentScreenshot);
      if (proofErr) return proofErr;

      let paymentScreenshotUrl = '';
      try {
        paymentScreenshotUrl = await savePaymentScreenshot(paymentScreenshot);
      } catch (uploadErr) {
        console.error('Payment screenshot save failed:', uploadErr);
        return {
          error: uploadErr.message || 'Payment screenshot save failed.',
        };
      }

      // Check username uniqueness
      const q = query(
        collection(db, 'users'),
        where('username', '==', username)
      );
      const existing = await getDocs(q);
      if (!existing.empty) return { error: 'Username already exists.' };

      const docRef = await addDoc(collection(db, 'users'), {
        name,
        username,
        password,
        approved: false,
        paymentRef: paymentRef || '',
        paymentScreenshotUrl,
        email: email || '',
        phone: phone || '',
        requestedAt: new Date().toISOString(),
        paymentSubmittedAt: serverTimestamp(),
        createdAt: serverTimestamp(),
      });

      const nu = {
        id: docRef.id,
        name,
        username,
        password,
        approved: false,
        paymentRef: paymentRef || '',
        paymentScreenshotUrl,
        email: email || '',
        phone: phone || '',
      };
      setCurrentUser(nu);
      localStorage.setItem('lv_session_id', docRef.id);
      localStorage.setItem('lv_session_role', 'student');
      return { success: true };
    } catch (e) {
      console.error('Signup Error:', e);
      return { error: 'Signup failed: ' + e.message };
    }
  };
  const signupInstructor = ({ email, password, name, about }) => {
    if (!email.includes('@gmail.com')) return { error: 'Use a Gmail address.' };
    const all = LS.get('lv_instructors') || [];
    if (all.find(i => i.email.toLowerCase() === email.toLowerCase()))
      return { error: 'Instructor already exists.' };
    const instructor = {
      id: `i_${Date.now()}`,
      email,
      password,
      name: name || nameFromEmail(email),
      about: about || 'New instructor',
      rating: 0,
      approved: false,
      requestedAt: new Date().toISOString(),
    };
    saveInstructors([...all, instructor]);
    return { success: true };
  };

  const loginWithSocialProfile = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const email = user.email;
      const name = user.displayName;
      const username = email.toLowerCase();

      // Check if user exists in Firestore
      const q = query(
        collection(db, 'users'),
        where('username', '==', username)
      );
      const snap = await getDocs(q);

      let u;
      if (snap.empty) {
        // Create new unapproved user
        const docRef = await addDoc(collection(db, 'users'), {
          name: name || email,
          username,
          password: 'google_oauth',
          approved: false,
          paymentRef: '',
          requestedAt: new Date().toISOString(),
          createdAt: serverTimestamp(),
          provider: 'google',
          photoURL: user.photoURL || '',
          email: email || '',
          phone: user.phoneNumber || '',
        });
        u = {
          id: docRef.id,
          name: name || email,
          username,
          approved: false,
          paymentRef: '',
          email: email || '',
          phone: user.phoneNumber || '',
        };
      } else {
        u = { id: snap.docs[0].id, ...snap.docs[0].data() };
      }

      setCurrentUser(u);
      localStorage.setItem('lv_session_id', u.id);
      localStorage.setItem('lv_session_role', 'student');
      return { success: true };
    } catch (e) {
      console.error('Google Auth Error:', e);
      return { error: 'Google Sign-In failed: ' + e.message };
    }
  };

  const submitPaymentProof = async ({ paymentRef, paymentScreenshot }) => {
    if (!currentUser?.id) return { error: 'Not logged in.' };
    const refText = (paymentRef || '').trim();
    if (!refText)
      return { error: 'Please enter your transaction reference ID.' };

    const proofErr = validatePaymentProofFile(paymentScreenshot);
    if (proofErr) return proofErr;

    try {
      const paymentScreenshotUrl =
        await savePaymentScreenshot(paymentScreenshot);
      await updateDoc(doc(db, 'users', currentUser.id), {
        paymentRef: refText,
        paymentScreenshotUrl,
        paymentSubmittedAt: new Date().toISOString(),
      });
      setCurrentUser(prev => ({
        ...prev,
        paymentRef: refText,
        paymentScreenshotUrl,
        paymentSubmittedAt: new Date().toISOString(),
      }));
      return { success: true };
    } catch (e) {
      console.error('submitPaymentProof:', e);
      return { error: e.message || 'Payment proof upload failed.' };
    }
  };

  // refreshUser — Firestore onSnapshot keeps state live; this is a manual fallback
  const refreshUser = useCallback(async () => {
    if (!currentUser?.id) return;
    try {
      const snap = await getDoc(doc(db, 'users', currentUser.id));
      if (snap.exists()) setCurrentUser({ id: snap.id, ...snap.data() });
    } catch {}
  }, [currentUser?.id]);

  const approveUser = async id => {
    await updateDoc(doc(db, 'users', id), { approved: true });
  };
  const revokeUser = async id => {
    await updateDoc(doc(db, 'users', id), { approved: false });
  };
  const deleteUser = async id => {
    await deleteDoc(doc(db, 'users', id));
  };
  const approveInstructor = id =>
    saveInstructors(
      instructors.map(i => (i.id === id ? { ...i, approved: true } : i))
    );
  const revokeInstructor = id =>
    saveInstructors(
      instructors.map(i => (i.id === id ? { ...i, approved: false } : i))
    );

  const createUser = async ({ name, username, password, email, phone }) => {
    try {
      const q = query(
        collection(db, 'users'),
        where('username', '==', username)
      );
      const existing = await getDocs(q);
      if (!existing.empty) return { error: 'Username already exists.' };
      await addDoc(collection(db, 'users'), {
        name,
        username,
        password,
        approved: true,
        paymentRef: '',
        email: email || '',
        phone: phone || '',
        requestedAt: new Date().toISOString(),
        createdAt: serverTimestamp(),
      });
      return { success: true };
    } catch (e) {
      return { error: 'Failed to create user.' };
    }
  };

  const createCourse = ({ title, description, thumb, instructorId, price }) => {
    const c = {
      id: `c_${Date.now()}`,
      title,
      description: description || '',
      thumb:
        thumb ||
        'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&q=80',
      instructorId: instructorId || currentInstructor?.id || null,
      approved: !(instructorId || currentInstructor?.id),
      status: instructorId || currentInstructor?.id ? 'pending' : 'approved',
      isBestSeller: false,
      price: Number(price) || 0,
      videos: [],
    };
    saveCourses([...courses, c]);
    return c;
  };
  const deleteCourse = id => saveCourses(courses.filter(c => c.id !== id));
  const approveCourse = id =>
    saveCourses(
      courses.map(c =>
        c.id === id ? { ...c, approved: true, status: 'approved' } : c
      )
    );
  const rejectCourse = id =>
    saveCourses(
      courses.map(c =>
        c.id === id ? { ...c, approved: false, status: 'rejected' } : c
      )
    );
  const toggleBestSeller = id =>
    saveCourses(
      courses.map(c =>
        c.id === id ? { ...c, isBestSeller: !c.isBestSeller } : c
      )
    );

  const updateCoursePrice = async (courseId, newPrice) => {
    const numericPrice = Number(newPrice);
    if (isNaN(numericPrice) || numericPrice < 0) {
      return { error: 'Please enter a valid price.' };
    }
    const updated = courses.map(c =>
      c.id === courseId ? { ...c, price: numericPrice } : c
    );
    saveCourses(updated);

    try {
      await setDoc(
        doc(db, 'settings', 'courses'),
        {
          prices: {
            [courseId]: numericPrice,
          },
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
    } catch (err) {
      console.warn('Could not sync course price to Firestore:', err);
    }

    return { success: true };
  };

  const addVideo = (
    courseId,
    { title, url, duration, storageKey, sourceType, fileName, preview }
  ) => {
    const v = {
      id: `v_${Date.now()}`,
      title,
      url: url || '',
      duration: duration || '—',
      storageKey: storageKey || null,
      sourceType: sourceType || 'url',
      fileName: fileName || '',
      preview: Boolean(preview),
    };
    saveCourses(
      courses.map(c =>
        c.id === courseId ? { ...c, videos: [...c.videos, v] } : c
      )
    );
  };
  const removeVideo = (courseId, videoId) => {
    saveCourses(
      courses.map(c =>
        c.id === courseId
          ? { ...c, videos: c.videos.filter(v => v.id !== videoId) }
          : c
      )
    );
  };
  const toggleVideoPreview = (courseId, videoId) => {
    saveCourses(
      courses.map(c =>
        c.id === courseId
          ? {
              ...c,
              videos: c.videos.map(v =>
                v.id === videoId ? { ...v, preview: !v.preview } : v
              ),
            }
          : c
      )
    );
  };
  const updateInstructor = patch => {
    if (!currentInstructor) return;
    const updated = { ...currentInstructor, ...patch };
    saveInstructors(
      (LS.get('lv_instructors') || []).map(i =>
        i.id === updated.id ? updated : i
      )
    );
    setCurrentInstructor(updated);
  };
  const markVideoComplete = (courseId, videoId) => {
    if (!currentUser || !courseId || !videoId) return;
    const all = LS.get('lv_progress') || [];
    const exists = all.some(
      p =>
        p.userId === currentUser.id &&
        p.courseId === courseId &&
        p.videoId === videoId
    );
    if (!exists)
      saveProgress([
        ...all,
        {
          userId: currentUser.id,
          courseId,
          videoId,
          completedAt: new Date().toISOString(),
        },
      ]);
  };
  const getCoursePercent = (userId, course) => {
    if (!course?.videos?.length) return 0;
    const done = progress.filter(
      p => p.userId === userId && p.courseId === course.id
    ).length;
    return Math.round((done / course.videos.length) * 100);
  };
  const addReview = ({ courseId, rating, comment }) => {
    if (!currentUser || !courseId || !rating) return;
    const all = LS.get('lv_reviews') || [];
    const next = all.filter(
      r => !(r.userId === currentUser.id && r.courseId === courseId)
    );
    saveReviews([
      ...next,
      {
        id: `r_${Date.now()}`,
        userId: currentUser.id,
        userName: currentUser.name,
        courseId,
        rating: Number(rating),
        comment: comment || '',
        createdAt: new Date().toISOString(),
      },
    ]);
  };
  const requestEnrollment = courseId => {
    if (!currentUser || !courseId) return;
    const all = LS.get('lv_enrollments') || [];
    const exists = all.some(
      e => e.userId === currentUser.id && e.courseId === courseId
    );
    if (!exists)
      saveEnrollments([
        ...all,
        {
          id: `e_${Date.now()}`,
          userId: currentUser.id,
          userName: currentUser.name,
          courseId,
          status: 'pending',
          requestedAt: new Date().toISOString(),
        },
      ]);
  };
  const approveEnrollment = id =>
    saveEnrollments(
      enrollments.map(e => (e.id === id ? { ...e, status: 'approved' } : e))
    );
  const rejectEnrollment = id =>
    saveEnrollments(
      enrollments.map(e => (e.id === id ? { ...e, status: 'rejected' } : e))
    );
  const isEnrolled = (userId, courseId) =>
    enrollments.some(
      e =>
        e.userId === userId &&
        e.courseId === courseId &&
        e.status === 'approved'
    );
  const enrollmentStatus = (userId, courseId) =>
    enrollments.find(e => e.userId === userId && e.courseId === courseId)
      ?.status || 'none';
  const addToCart = courseId => {
    if (!courseId || cart.includes(courseId)) return;
    saveCart([...cart, courseId]);
  };
  const removeFromCart = courseId =>
    saveCart(cart.filter(id => id !== courseId));
  const clearCart = () => saveCart([]);

  return (
    <AuthCtx.Provider
      value={{
        currentUser,
        currentInstructor,
        isAdmin,
        users,
        instructors,
        courses,
        progress,
        reviews,
        enrollments,
        cart,
        loginStudent,
        loginAdmin,
        loginInstructor,
        signupStudent,
        signupInstructor,
        loginWithSocialProfile,
        logout,
        refreshUser,
        approveUser,
        revokeUser,
        deleteUser,
        createUser,
        approveInstructor,
        revokeInstructor,
        submitPaymentProof,
        createCourse,
        deleteCourse,
        approveCourse,
        rejectCourse,
        toggleBestSeller,
        updateCoursePrice,
        addVideo,
        removeVideo,
        toggleVideoPreview,
        updateInstructor,
        markVideoComplete,
        getCoursePercent,
        addReview,
        requestEnrollment,
        approveEnrollment,
        rejectEnrollment,
        isEnrolled,
        enrollmentStatus,
        addToCart,
        removeFromCart,
        clearCart,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
